var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{staticClass:"item-menu",attrs:{"exact-active-class":"active-logged-link","to":_vm.link}},[_c('img',{attrs:{"src":_vm.imgSrc,"alt":_vm.imgAlt}}),_c('p',[_vm._v(" "+_vm._s(_vm.text)+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }